import { ContentPanel } from '@/components/content-panel';
import { Logo } from '@/components/logo';
import { useLayoutContext } from '@/contexts';
import { safeAreaTop } from '@/utils';
import { Box, Flex, Space, Text, Title } from '@mantine/core';
import { SignupImage } from './signup-image';
import styles from './styles.module.css';

export const SignupHeader = () => {
	const notchPadding = safeAreaTop();
	const { isDesktop } = useLayoutContext();

	return (
		<Flex h={279 + notchPadding} w="100%" direction="column" className={styles.top}>
			<ContentPanel py="md" style={{ overflow: 'hidden' }} noPad>
				<Flex direction="row" justify="space-between" pos="relative" align="center" w="100%">
					<Flex direction="column" w="100%" gap="sm">
						<Space h={notchPadding} />
						<Logo />
						<Text
							c="white"
							fw={700}
							fz={isDesktop ? '32px' : '20px'}
							w={isDesktop ? '500px' : '66%'}
						>
							Recycle with Curby and have a chance to win!
						</Text>
						<Title order={isDesktop ? 1 : 1}>Sign Up</Title>
					</Flex>
					{!isDesktop ? (
						<Flex pos="absolute" top={0} right={-130}>
							<SignupImage />
						</Flex>
					) : (
						<SignupImage />
					)}
				</Flex>
			</ContentPanel>
			<Box className={styles.bottom} />
		</Flex>
	);
};
